











import Vue from "vue";
import Component from "vue-class-component";

@Component({
  metaInfo: {
    title: "Statistiken",
  },
})
export default class Statistics extends Vue {}
